var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.97,
    height: 22.31,
    viewBox: "0 0 22.97 22.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "question-answer"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,22.7a1.15,1.15,0,0,1-.6-.9v-.9a3.26,3.26,0,0,1-3-3.5V13.7a3.31,3.31,0,0,1,3.5-3.5h6.1a3.31,3.31,0,0,1,3.5,3.5v3.7a3.31,3.31,0,0,1-3.5,3.5H8L5.4,22.6A.9.9,0,0,1,4.3,22.7Zm6-11.5H4.2a2.42,2.42,0,0,0-2.6,2.6v3.7a2.42,2.42,0,0,0,2.6,2.6.54.54,0,0,1,.5.5v1.3c0,.1,0,.1.1.1H5l2.7-1.8a.22.22,0,0,1,.2-.2h2.4a2.42,2.42,0,0,0,2.6-2.6V13.7A2.39,2.39,0,0,0,10.3,11.2Z",
    transform: "translate(-0.41 -0.82)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.59,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,16.6a.71.71,0,0,1,.7.8.77.77,0,0,1-.7.8H4.3a.71.71,0,0,1-.7-.8.77.77,0,0,1,.7-.8Z",
    transform: "translate(-0.41 -0.82)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,13.3c.3,0,.6.3.6.8s-.3.8-.6.8H5.7c-.3,0-.6-.3-.6-.8s.3-.8.6-.8Z",
    transform: "translate(-0.41 -0.82)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.12
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4,13.5l-2.6-1.7H13.5A3.31,3.31,0,0,1,10,8.3V4.6a3.31,3.31,0,0,1,3.5-3.5h6.1a3.31,3.31,0,0,1,3.5,3.5V8.3a3.33,3.33,0,0,1-3,3.5v.9a.87.87,0,0,1-.6.9A1.07,1.07,0,0,1,18.4,13.5ZM10.9,4.6V8.3a2.42,2.42,0,0,0,2.6,2.6h2.4a.37.37,0,0,1,.3.1l2.7,1.8h.2l.1-.1V11.4a.54.54,0,0,1,.5-.5,2.42,2.42,0,0,0,2.6-2.6V4.6A2.42,2.42,0,0,0,19.7,2H13.6A2.49,2.49,0,0,0,10.9,4.6Z",
    transform: "translate(-0.41 -0.82)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.55,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(14.53 9.11) rotate(-0.27)",
    fontSize: 10,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.41 -0.82)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.41 -0.82)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAnswer);
export default __webpack_public_path__ + "static/media/question-answer.8d11d205e1cea770ca5ea7f9dda6d508.svg";
export { ForwardRef as ReactComponent };